import {
    transition, animate, style, trigger, state
  } from "@angular/animations";

export const openClose = trigger("openClose", [
    state("true", style({ height: "*" })),
    state("false", style({ height: "0" })),
    transition("false <=> true", animate(200))
]);
